import { render, staticRenderFns } from "./SearchForm.vue?vue&type=template&id=c4c8703e&scoped=true&"
import script from "./SearchForm.vue?vue&type=script&lang=js&"
export * from "./SearchForm.vue?vue&type=script&lang=js&"
import style0 from "./SearchForm.vue?vue&type=style&index=0&id=c4c8703e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c8703e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/danielescotti/htdocs/edilizia-acrobatica-wp/web/app/themes/edilizia-acrobatica-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4c8703e')) {
      api.createRecord('c4c8703e', component.options)
    } else {
      api.reload('c4c8703e', component.options)
    }
    module.hot.accept("./SearchForm.vue?vue&type=template&id=c4c8703e&scoped=true&", function () {
      api.rerender('c4c8703e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/components/SearchForm/SearchForm.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/components/SearchForm/SearchForm.vue
// module id = 31
// module chunks = 0